@if (show()) {
  <section
    class="w-[calc(100%-2.5rem)] h-full absolute top-0 left-xl z-1 bg-neutral-50 rounded-md overflow-hidden flex items-center justify-center">
    <div
      class="flex flex-col justify-center items-center h-full gap-5xl p-xl max-h-full overflow-y-auto">
      <lib-medical-case-icon
        [iconClass]="'w-[10.5rem] h-[9.375rem] shrink-0'" />

      <div class="text-center flex flex-col gap-md max-w-[32rem]">
        <h1 class="text-2xl font-bold text-neutral-900">
          {{ 'domain_moved_title' | transloco }}
        </h1>

        <p class="text-base text-neutral-500">
          {{ 'domain_moved_description' | transloco }}
        </p>

        <a
          [href]="targetDomain"
          class="text-lg font-bold text-primary-600 hover:text-primary-700 transition-colors">
          {{ targetDomain }}
        </a>

        <div
          class="mt-xl p-xl bg-white rounded-xl shadow-sm border border-neutral-100 w-full animate-fade-in-up">
          <p class="text-sm font-semibold text-neutral-800 text-left mb-sm">
            {{ 'convert_old_link_title' | transloco }}
          </p>
          <p class="text-xs text-neutral-500 text-left mb-md">
            {{ 'convert_old_link_description' | transloco }}
          </p>

          <div class="flex flex-col gap-sm">
            <input
              type="url"
              [ngModel]="oldUrl()"
              (ngModelChange)="oldUrl.set($event)"
              [placeholder]="'old_link_placeholder' | transloco"
              class="w-full px-md py-sm border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm h-[2.625rem] bg-neutral-50" />

            @if (transformedUrl()) {
              <div class="mt-sm text-left animate-fade-in">
                <p class="text-xs font-semibold text-neutral-700 mb-xs">
                  {{ 'new_url_label' | transloco }}
                </p>
                <div class="flex flex-row items-center gap-sm">
                  <input
                    readonly
                    [value]="transformedUrl()"
                    class="flex-1 bg-white px-md py-sm border border-primary-500/30 rounded-md text-sm text-neutral-700 h-[2.625rem] focus:outline-none focus:ring-1 focus:ring-primary-500/50" />
                  <a
                    [href]="transformedUrl()"
                    target="_blank"
                    class="bg-primary-600 hover:opacity-90 text-white px-xl py-sm h-[2.625rem] rounded-md text-sm font-medium transition-all shadow-sm flex items-center justify-center shrink-0">
                    {{ 'open_link' | transloco }}
                  </a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
}
